<app-container [sidebar]="true">
  <app-header-meta-action [title]="today()">
    <button appTailwindButton (click)="startTimer()">Start Timer</button>
  </app-header-meta-action>

  <app-sidebar-navigation>
    <app-sidebar-navigation-entry
      iconName="heroCalendar"
      iconOpenName="heroCalendarDays"
      [routerLink]="'calendar'"
    >
      Kalender
    </app-sidebar-navigation-entry>

    <app-sidebar-navigation-entry
      iconName="heroClock"
      iconOpenName="heroClock"
      [routerLink]="'work'"
    >
      Meine Stunden</app-sidebar-navigation-entry
    >
    @let openMentions = numberOfMentions | async;
    @if (openMentions) {
      <app-sidebar-navigation-entry
        iconName="heroChatBubbleBottomCenter"
        iconOpenName="heroChatBubbleBottomCenterText"
        [routerLink]="'comments'"
      >
        <div class="flex justify-between items-center">
          <span class="truncate">Offene Tasks</span
          ><span class="font-normal text-xs">{{ openMentions }}</span>
        </div>
      </app-sidebar-navigation-entry>
    }
  </app-sidebar-navigation>

  <router-outlet></router-outlet>
</app-container>
